// Copyright (c) 2016 Deere & Company

import KeyValuePair, {getDefaultState as getKeyValueDefaultState} from './key-value-pair';
import t from 'tcomb';

const ClaimOtherCredit = t.struct({
    amount: t.maybe(t.Number),
    comments: t.String,
    details: KeyValuePair,
    distance: t.maybe(t.Number),
    guid: t.String,
    id: t.String,
    lineNumber: t.Number,
    otherCreditAmount: t.maybe(t.Number),
    reimbursementAmount: t.maybe(t.Number),
    taxAmount: t.maybe(t.Number)
}, {
    name: 'ClaimOtherCredit',
    strict: true
});

export const getDefaultState = () => new ClaimOtherCredit({
    amount: null,
    comments: '',
    details: getKeyValueDefaultState(),
    guid: '',
    id: '',
    lineNumber: 0
});

export default ClaimOtherCredit;



// WEBPACK FOOTER //
// ./~/@deere/cps-it.warranty-model-factory/lib/claim-item-other-credit.js